export default __webpack_public_path__ + "static/media/callIcon.6d627e16.png";